import React from "react";
import { Folder, Home } from "react-feather";

interface BreadcrumbItem {
  name: string;
  path: string;
}

interface FolderBreadcrumbProps {
  items: BreadcrumbItem[];
  onNavigate: (path: string) => void;
}

export function FolderBreadcrumb({ items, onNavigate }: FolderBreadcrumbProps) {
  return (
    <div className="breadcrumbs text-sm">
      <ul>
        <li>
          <button
            className="btn btn-ghost btn-xs px-1 py-2"
            onClick={() => onNavigate("")}
          >
            <Folder size={14} />
          </button>
        </li>
        {items.map((item, index) => (
          <li key={item.path}>
            <button
              className="btn btn-ghost btn-xs"
              onClick={() => onNavigate(item.path)}
            >
              {item.name}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
